import { z } from "zod";
import { Text, type WidgetModule, type WidgetRenderContext } from "@salestrak/ui";
import { AttachmentsWidgetBody } from "#app/widgets/summary/attachments-widget-body";
import { useIssueWidgetContext } from "#app/widgets/issue/issue-widget-context";

export const issueAttachmentsConfigSchema = z.looseObject({ limit: z.number().default(5) });
export type IssueAttachmentsConfig = z.infer<typeof issueAttachmentsConfigSchema>;

function IssueAttachmentsRender({ config }: WidgetRenderContext<IssueAttachmentsConfig>) {
  const ctx = useIssueWidgetContext();
  return (
    <AttachmentsWidgetBody
      entityId={ctx.issue?.issueId ?? ""}
      entityName={ctx.issue?.name}
      items={ctx.mediaItems ?? []}
      limit={config.limit}
      onNavigateFallback={() => ctx.onNavigateTab?.("media")}
    />
  );
}

function IssueAttachmentsTitleAdornment() {
  const ctx = useIssueWidgetContext();
  const count = ctx.mediaItems?.length ?? 0;

  if (count === 0) return null;

  return (
    <Text size="xs" variant="muted" tabular>
      {count}
    </Text>
  );
}

export const issueAttachmentsDef: WidgetModule<IssueAttachmentsConfig> = {
  type: "issue-attachments",
  title: "Attachments",
  icon: "paperclip",
  span: { minW: 3, minH: 2, maxW: 12, maxH: 12, defaultW: 12, defaultH: 3 },
  configSchema: issueAttachmentsConfigSchema,
  titleAdornment: IssueAttachmentsTitleAdornment,
  render: IssueAttachmentsRender,
};
